import { useCallback } from "react";
import t from "../../../../../i18n";
import { useCreateRemoteDashboardCallback } from "../api/dashboard";
import { useUser } from "../../../../../api/useUser";

export const useDashboardCreateCallback = (projectId: string) => {
  const user = useUser();
  const createRemoteDashboard = useCreateRemoteDashboardCallback();

  return useCallback(() => {
    const dashboard = {
      id: globalThis.crypto.randomUUID(),
      createdByUserId: user.id,
      createdByUserName: user.name,
      updatedByUserName: user.name,
      projectId,
      createdAt: Date.now(),
      updatedAt: Date.now(),
      title: t("project.dashboard.title.empty"),
      blocks: [],
      published: false,
      readonly: false,
      description: null,
    };
    return createRemoteDashboard(dashboard);
  }, [user.id, user.name, projectId, createRemoteDashboard]);
};
